module.exports = __webpack_public_path__ + "media/assets/img/user-3e6c171367844990ae393a18409b14ca.svg";